import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../utils/updateObject";
import operationsName from "../../utils/operationsName";
import tablesName from "../../utils/tablesName";

const initialState = {
  logs: { count: 0, rows: [] },
  logsFilter: {
    page: 1,
    limit: 25,
    search: "",
    order: "desc",
    orderBy: "createdAt",
    startDate: null,
    endDate: null,
    filteredUsers: [],
    filteredTypes: [],
    filteredOperationsName: [],
    filteredTables: [],
    filteredDocumentsIds: []
  },
  elementFilter: {
    page: 1,
    limit: 25,
    search: "",
    order: "desc",
    orderBy: "createdAt",
    startDate: null,
    endDate: null,
    filteredUsers: [],
    filteredTypes: [],
    filteredOperationsName: [],
    filteredTables: [],
  },
  types: [
    // {
    //   value: 'get',
    //   label: 'get',
    // },
    {
      value: 'insert',
      label: 'insert',
    },
    {
      value: 'update',
      label: 'update',
    },
    {
      value: 'delete',
      label: 'delete',
    },
  ],
  operationsName,
  tables: tablesName,
  log: {},
  loading: false,
  loadingLog: false,
  employeeLogs: {
    count: 0,
    rows: []
  },
  employeeLoading: false
};

const requestLogsStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const requestLogByIdStart = (state, action) => {
  return updateObject(state, { loadingLog: true });
};

const requestLogsByEmployeeIdStart = (state, action) => {
  return updateObject(state, { employeeLoading: true })
}

const fetchLogsSuccess = (state, action) => {
  return updateObject(state, {
    logs: action.logs,
    loading: false,
  });
};

const setLogsFilter = (state, action) => {
  return updateObject(state, {
    logsFilter: action.logsFilter,
  });
};

const setLogsUsersFilter = (state, action) => {
  return updateObject(state, {
    logsFilter: {
      ...state.logsFilter,
      filteredUsers: action.users
    }
  })
}

const setLogsByElementIdFilter = (state, action) => {
  return updateObject(state, {
    elementFilter: action.elementFilter
  })
}

const fetchLogsByIdSuccess = (state, action) => {
  return updateObject(state, {
    log: action.log,
    loadingLog: false
  });
}

const fetchLogsByEmployeeIdSuccess = (state, action) => {
  return updateObject(state, {
    employeeLogs: action.log,
    employeeLoading: false
  })
}

const postOpenDocLog = (state) => {
  return state
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_LOGS_START:
      return requestLogsStart(state, action);
    case actionTypes.REQUEST_LOG_BY_ID_START:
      return requestLogByIdStart(state, action);
    case actionTypes.REQUEST_LOGS_BY_EMPLOYEE_ID_START:
      return requestLogsByEmployeeIdStart(state, action);
    case actionTypes.FETCH_LOGS_SUCCESS:
      return fetchLogsSuccess(state, action);
    case actionTypes.SET_LOGS_FILTER:
      return setLogsFilter(state, action);
    case actionTypes.SET_LOGS_USERS_FILTER:
      return setLogsUsersFilter(state, action);
    case actionTypes.SET_LOGS_BY_ELEMENT_ID_FILTER:
      return setLogsByElementIdFilter(state, action);
    case actionTypes.FETCH_LOG_BY_ID_SUCCESS:
      return fetchLogsByIdSuccess(state, action);
    case actionTypes.FETCH_LOGS_BY_EMPLOYEE_ID_SUCCESS:
      return fetchLogsByEmployeeIdSuccess(state, action);
    case actionTypes.POST_OPEN_DOC_LOG:
      return postOpenDocLog(state)
    default:
      return state;
  }
};

export default reducer;
